/* eslint-disable */
// @ts-nocheck
/**
 * AUTO-GENERATED by scripts/generateFilterGrammarParser.ts — DO NOT EDIT.
 *
 * Precompiled, eval-free parser for the metric filter grammar. Regenerate with
 * `pnpm -F common generate:filter-grammar-parser` after editing
 * filterGrammar.grammar.ts.
 */
export const filterGrammarParser /*
 * Generated by PEG.js 0.10.0.
 *
 * http://pegjs.org/
 */ = (function () {
    'use strict';
    function peg$subclass(child, parent) {
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
    }
    function peg$SyntaxError(message, expected, found, location) {
        this.message = message;
        this.expected = expected;
        this.found = found;
        this.location = location;
        this.name = 'SyntaxError';
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, peg$SyntaxError);
        }
    }
    peg$subclass(peg$SyntaxError, Error);
    peg$SyntaxError.buildMessage = function (expected, found) {
        var DESCRIBE_EXPECTATION_FNS = {
            literal: function (expectation) {
                return '"' + literalEscape(expectation.text) + '"';
            },
            class: function (expectation) {
                var escapedParts = '', i;
                for (i = 0; i < expectation.parts.length; i++) {
                    escapedParts +=
                        expectation.parts[i] instanceof Array
                            ? classEscape(expectation.parts[i][0]) +
                                '-' +
                                classEscape(expectation.parts[i][1])
                            : classEscape(expectation.parts[i]);
                }
                return ('[' + (expectation.inverted ? '^' : '') + escapedParts + ']');
            },
            any: function (expectation) {
                return 'any character';
            },
            end: function (expectation) {
                return 'end of input';
            },
            other: function (expectation) {
                return expectation.description;
            },
        };
        function hex(ch) {
            return ch.charCodeAt(0).toString(16).toUpperCase();
        }
        function literalEscape(s) {
            return s
                .replace(/\\/g, '\\\\')
                .replace(/"/g, '\\"')
                .replace(/\0/g, '\\0')
                .replace(/\t/g, '\\t')
                .replace(/\n/g, '\\n')
                .replace(/\r/g, '\\r')
                .replace(/[\x00-\x0F]/g, function (ch) {
                return '\\x0' + hex(ch);
            })
                .replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
                return '\\x' + hex(ch);
            });
        }
        function classEscape(s) {
            return s
                .replace(/\\/g, '\\\\')
                .replace(/\]/g, '\\]')
                .replace(/\^/g, '\\^')
                .replace(/-/g, '\\-')
                .replace(/\0/g, '\\0')
                .replace(/\t/g, '\\t')
                .replace(/\n/g, '\\n')
                .replace(/\r/g, '\\r')
                .replace(/[\x00-\x0F]/g, function (ch) {
                return '\\x0' + hex(ch);
            })
                .replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
                return '\\x' + hex(ch);
            });
        }
        function describeExpectation(expectation) {
            return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
        }
        function describeExpected(expected) {
            var descriptions = new Array(expected.length), i, j;
            for (i = 0; i < expected.length; i++) {
                descriptions[i] = describeExpectation(expected[i]);
            }
            descriptions.sort();
            if (descriptions.length > 0) {
                for (i = 1, j = 1; i < descriptions.length; i++) {
                    if (descriptions[i - 1] !== descriptions[i]) {
                        descriptions[j] = descriptions[i];
                        j++;
                    }
                }
                descriptions.length = j;
            }
            switch (descriptions.length) {
                case 1:
                    return descriptions[0];
                case 2:
                    return descriptions[0] + ' or ' + descriptions[1];
                default:
                    return (descriptions.slice(0, -1).join(', ') +
                        ', or ' +
                        descriptions[descriptions.length - 1]);
            }
        }
        function describeFound(found) {
            return found ? '"' + literalEscape(found) + '"' : 'end of input';
        }
        return ('Expected ' +
            describeExpected(expected) +
            ' but ' +
            describeFound(found) +
            ' found.');
    };
    function peg$parse(input, options) {
        options = options !== void 0 ? options : {};
        var peg$FAILED = {}, peg$startRuleFunctions = { ROOT: peg$parseROOT }, peg$startRuleFunction = peg$parseROOT, peg$c0 = '', peg$c1 = function () {
            return {
                type: 'equals',
                values: [],
                is: true,
            };
        }, peg$c2 = 'between', peg$c3 = peg$literalExpectation('between', true), peg$c4 = 'BETWEEN', peg$c5 = peg$literalExpectation('BETWEEN', false), peg$c6 = 'and', peg$c7 = peg$literalExpectation('and', true), peg$c8 = 'AND', peg$c9 = peg$literalExpectation('AND', false), peg$c10 = function (min, max) {
            return {
                type: 'inBetween',
                values: [min, max],
                is: true,
            };
        }, peg$c11 = function (operator, value) {
            return {
                type: operator,
                values: [value],
            };
        }, peg$c12 = '>=', peg$c13 = peg$literalExpectation('>=', false), peg$c14 = '<=', peg$c15 = peg$literalExpectation('<=', false), peg$c16 = '>', peg$c17 = peg$literalExpectation('>', false), peg$c18 = '<', peg$c19 = peg$literalExpectation('<', false), peg$c20 = function (date) {
            return date;
        }, peg$c21 = '-', peg$c22 = peg$literalExpectation('-', false), peg$c23 = 'T', peg$c24 = peg$literalExpectation('T', false), peg$c25 = 'Z', peg$c26 = peg$literalExpectation('Z', false), peg$c27 = function (year, month, day, time) {
            return text();
        }, peg$c28 = /^[0-9]/, peg$c29 = peg$classExpectation([['0', '9']], false, false), peg$c30 = '0', peg$c31 = peg$literalExpectation('0', false), peg$c32 = /^[1-9]/, peg$c33 = peg$classExpectation([['1', '9']], false, false), peg$c34 = '1', peg$c35 = peg$literalExpectation('1', false), peg$c36 = /^[0-2]/, peg$c37 = peg$classExpectation([['0', '2']], false, false), peg$c38 = /^[1-2]/, peg$c39 = peg$classExpectation([['1', '2']], false, false), peg$c40 = '3', peg$c41 = peg$literalExpectation('3', false), peg$c42 = /^[0-1]/, peg$c43 = peg$classExpectation([['0', '1']], false, false), peg$c44 = ':', peg$c45 = peg$literalExpectation(':', false), peg$c46 = '.', peg$c47 = peg$literalExpectation('.', false), peg$c48 = function (operator, value, interval) {
            return {
                type: operator,
                values: [value],
                date_interval: interval,
            };
        }, peg$c49 = 'inThePast', peg$c50 = peg$literalExpectation('inThePast', false), peg$c51 = 'inTheNext', peg$c52 = peg$literalExpectation('inTheNext', false), peg$c53 = 'milliseconds', peg$c54 = peg$literalExpectation('milliseconds', false), peg$c55 = 'seconds', peg$c56 = peg$literalExpectation('seconds', false), peg$c57 = 'minutes', peg$c58 = peg$literalExpectation('minutes', false), peg$c59 = 'hours', peg$c60 = peg$literalExpectation('hours', false), peg$c61 = 'days', peg$c62 = peg$literalExpectation('days', false), peg$c63 = 'weeks', peg$c64 = peg$literalExpectation('weeks', false), peg$c65 = 'months', peg$c66 = peg$literalExpectation('months', false), peg$c67 = 'years', peg$c68 = peg$literalExpectation('years', false), peg$c69 = function (operator, interval) {
            return {
                type: operator,
                values: [1],
                date_interval: interval,
            };
        }, peg$c70 = 'notInTheCurrent', peg$c71 = peg$literalExpectation('notInTheCurrent', false), peg$c72 = 'inTheCurrent', peg$c73 = peg$literalExpectation('inTheCurrent', false), peg$c74 = 'quarters', peg$c75 = peg$literalExpectation('quarters', false), peg$c76 = 'millisecond', peg$c77 = peg$literalExpectation('millisecond', false), peg$c78 = 'second', peg$c79 = peg$literalExpectation('second', false), peg$c80 = 'minute', peg$c81 = peg$literalExpectation('minute', false), peg$c82 = 'hour', peg$c83 = peg$literalExpectation('hour', false), peg$c84 = 'day', peg$c85 = peg$literalExpectation('day', false), peg$c86 = 'week', peg$c87 = peg$literalExpectation('week', false), peg$c88 = 'month', peg$c89 = peg$literalExpectation('month', false), peg$c90 = 'quarter', peg$c91 = peg$literalExpectation('quarter', false), peg$c92 = 'year', peg$c93 = peg$literalExpectation('year', false), peg$c94 = function (singular) {
            return singular + 's';
        }, peg$c95 = /^[Ee]/, peg$c96 = peg$classExpectation(['E', 'e'], false, false), peg$c97 = /^[+\-]/, peg$c98 = peg$classExpectation(['+', '-'], false, false), peg$c99 = function () {
            return Number(text());
        }, peg$c100 = function (left, right) {
            return {
                type: ',',
                left: left,
                right: right,
            };
        }, peg$c101 = function (not, term) {
            term.is = not ? false : true;
            return term;
        }, peg$c102 = 'EMPTY', peg$c103 = peg$literalExpectation('EMPTY', false), peg$c104 = 'empty', peg$c105 = peg$literalExpectation('empty', false), peg$c106 = function () {
            return {
                type: 'blank',
            };
        }, peg$c107 = 'NULL', peg$c108 = peg$literalExpectation('NULL', false), peg$c109 = 'null', peg$c110 = peg$literalExpectation('null', false), peg$c111 = function () {
            return {
                type: 'null',
            };
        }, peg$c112 = function (sequence) {
            return {
                type: 'equals',
                values: [sequence.join('')],
            };
        }, peg$c113 = function (sequence) {
            return {
                type: 'equals',
                values: [sequence.join('')],
            };
        }, peg$c114 = function (value) {
            return {
                type: 'include',
                values: [value.join('')],
            };
        }, peg$c115 = function (value) {
            return {
                type: 'startsWith',
                values: [value.join('')],
            };
        }, peg$c116 = function (value) {
            return {
                type: 'endsWith',
                values: [value.join('')],
            };
        }, peg$c117 = '!', peg$c118 = peg$literalExpectation('!', false), peg$c119 = peg$otherExpectation('string'), peg$c120 = function (str) {
            return str;
        }, peg$c121 = function (str) {
            return str ? str.trim() : str;
        }, peg$c122 = function (chars) {
            return '"' + chars.join('') + '"';
        }, peg$c123 = function (chars) {
            return chars.join('');
        }, peg$c124 = peg$otherExpectation('character'), peg$c125 = function (symbol) {
            return symbol;
        }, peg$c126 = '"', peg$c127 = peg$literalExpectation('"', false), peg$c128 = '\\', peg$c129 = peg$literalExpectation('\\', false), peg$c130 = '/', peg$c131 = peg$literalExpectation('/', false), peg$c132 = 'b', peg$c133 = peg$literalExpectation('b', false), peg$c134 = function () {
            return '\b';
        }, peg$c135 = 'f', peg$c136 = peg$literalExpectation('f', false), peg$c137 = function () {
            return '\f';
        }, peg$c138 = 'n', peg$c139 = peg$literalExpectation('n', false), peg$c140 = function () {
            return '\n';
        }, peg$c141 = 'r', peg$c142 = peg$literalExpectation('r', false), peg$c143 = function () {
            return '\r';
        }, peg$c144 = 't', peg$c145 = peg$literalExpectation('t', false), peg$c146 = function () {
            return '\t';
        }, peg$c147 = 'u', peg$c148 = peg$literalExpectation('u', false), peg$c149 = function (digits) {
            return String.fromCharCode(parseInt(digits, 16));
        }, peg$c150 = function (sequence) {
            return sequence;
        }, peg$c151 = function () {
            return ' ';
        }, peg$c152 = function (symbol) {
            return symbol;
        }, peg$c153 = '%', peg$c154 = peg$literalExpectation('%', false), peg$c155 = '_', peg$c156 = peg$literalExpectation('_', false), peg$c157 = ',', peg$c158 = peg$literalExpectation(',', false), peg$c159 = ' ', peg$c160 = peg$literalExpectation(' ', false), peg$c161 = '^ ', peg$c162 = peg$literalExpectation('^ ', false), peg$c163 = peg$anyExpectation(), peg$c164 = ' ^ ', peg$c165 = peg$literalExpectation(' ^ ', false), peg$c166 = '^', peg$c167 = peg$literalExpectation('^', false), peg$c168 = '\\"', peg$c169 = peg$literalExpectation('\\"', false), peg$c170 = function (char) {
            return char;
        }, peg$c171 = /^[^\0-\x1F"\\]/, peg$c172 = peg$classExpectation([['\0', '\x1F'], '"', '\\'], true, false), peg$c173 = /^[0-9a-f]/i, peg$c174 = peg$classExpectation([
            ['0', '9'],
            ['a', 'f'],
        ], false, true), peg$currPos = 0, peg$savedPos = 0, peg$posDetailsCache = [{ line: 1, column: 1 }], peg$maxFailPos = 0, peg$maxFailExpected = [], peg$silentFails = 0, peg$result;
        if ('startRule' in options) {
            if (!(options.startRule in peg$startRuleFunctions)) {
                throw new Error('Can\'t start parsing from rule "' +
                    options.startRule +
                    '".');
            }
            peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
        }
        function text() {
            return input.substring(peg$savedPos, peg$currPos);
        }
        function location() {
            return peg$computeLocation(peg$savedPos, peg$currPos);
        }
        function expected(description, location) {
            location =
                location !== void 0
                    ? location
                    : peg$computeLocation(peg$savedPos, peg$currPos);
            throw peg$buildStructuredError([peg$otherExpectation(description)], input.substring(peg$savedPos, peg$currPos), location);
        }
        function error(message, location) {
            location =
                location !== void 0
                    ? location
                    : peg$computeLocation(peg$savedPos, peg$currPos);
            throw peg$buildSimpleError(message, location);
        }
        function peg$literalExpectation(text, ignoreCase) {
            return { type: 'literal', text: text, ignoreCase: ignoreCase };
        }
        function peg$classExpectation(parts, inverted, ignoreCase) {
            return {
                type: 'class',
                parts: parts,
                inverted: inverted,
                ignoreCase: ignoreCase,
            };
        }
        function peg$anyExpectation() {
            return { type: 'any' };
        }
        function peg$endExpectation() {
            return { type: 'end' };
        }
        function peg$otherExpectation(description) {
            return { type: 'other', description: description };
        }
        function peg$computePosDetails(pos) {
            var details = peg$posDetailsCache[pos], p;
            if (details) {
                return details;
            }
            else {
                p = pos - 1;
                while (!peg$posDetailsCache[p]) {
                    p--;
                }
                details = peg$posDetailsCache[p];
                details = {
                    line: details.line,
                    column: details.column,
                };
                while (p < pos) {
                    if (input.charCodeAt(p) === 10) {
                        details.line++;
                        details.column = 1;
                    }
                    else {
                        details.column++;
                    }
                    p++;
                }
                peg$posDetailsCache[pos] = details;
                return details;
            }
        }
        function peg$computeLocation(startPos, endPos) {
            var startPosDetails = peg$computePosDetails(startPos), endPosDetails = peg$computePosDetails(endPos);
            return {
                start: {
                    offset: startPos,
                    line: startPosDetails.line,
                    column: startPosDetails.column,
                },
                end: {
                    offset: endPos,
                    line: endPosDetails.line,
                    column: endPosDetails.column,
                },
            };
        }
        function peg$fail(expected) {
            if (peg$currPos < peg$maxFailPos) {
                return;
            }
            if (peg$currPos > peg$maxFailPos) {
                peg$maxFailPos = peg$currPos;
                peg$maxFailExpected = [];
            }
            peg$maxFailExpected.push(expected);
        }
        function peg$buildSimpleError(message, location) {
            return new peg$SyntaxError(message, null, null, location);
        }
        function peg$buildStructuredError(expected, found, location) {
            return new peg$SyntaxError(peg$SyntaxError.buildMessage(expected, found), expected, found, location);
        }
        function peg$parseROOT() {
            var s0;
            s0 = peg$parseEXPRESSION();
            if (s0 === peg$FAILED) {
                s0 = peg$parseEMPTY_STRING();
            }
            return s0;
        }
        function peg$parseEMPTY_STRING() {
            var s0, s1;
            s0 = peg$currPos;
            s1 = peg$c0;
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c1();
            }
            s0 = s1;
            return s0;
        }
        function peg$parseEXPRESSION() {
            var s0;
            s0 = peg$parseBETWEEN_DATE();
            if (s0 === peg$FAILED) {
                s0 = peg$parseBETWEEN_NUMERICAL();
                if (s0 === peg$FAILED) {
                    s0 = peg$parseNUMERICAL();
                    if (s0 === peg$FAILED) {
                        s0 = peg$parseCURRENT_DATE_RESTRICTION();
                        if (s0 === peg$FAILED) {
                            s0 = peg$parseDATE_RESTRICTION();
                            if (s0 === peg$FAILED) {
                                s0 = peg$parseLIST();
                                if (s0 === peg$FAILED) {
                                    s0 = peg$parseTERM();
                                }
                            }
                        }
                    }
                }
            }
            return s0;
        }
        function peg$parseBETWEEN_DATE() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseSPACE_SYMBOL();
            while (s2 !== peg$FAILED) {
                s1.push(s2);
                s2 = peg$parseSPACE_SYMBOL();
            }
            if (s1 !== peg$FAILED) {
                if (input.substr(peg$currPos, 7).toLowerCase() === peg$c2) {
                    s2 = input.substr(peg$currPos, 7);
                    peg$currPos += 7;
                }
                else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c3);
                    }
                }
                if (s2 === peg$FAILED) {
                    if (input.substr(peg$currPos, 7) === peg$c4) {
                        s2 = peg$c4;
                        peg$currPos += 7;
                    }
                    else {
                        s2 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c5);
                        }
                    }
                }
                if (s2 !== peg$FAILED) {
                    s3 = [];
                    s4 = peg$parseSPACE_SYMBOL();
                    if (s4 !== peg$FAILED) {
                        while (s4 !== peg$FAILED) {
                            s3.push(s4);
                            s4 = peg$parseSPACE_SYMBOL();
                        }
                    }
                    else {
                        s3 = peg$FAILED;
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parseDATE_STRING();
                        if (s4 !== peg$FAILED) {
                            s5 = [];
                            s6 = peg$parseSPACE_SYMBOL();
                            if (s6 !== peg$FAILED) {
                                while (s6 !== peg$FAILED) {
                                    s5.push(s6);
                                    s6 = peg$parseSPACE_SYMBOL();
                                }
                            }
                            else {
                                s5 = peg$FAILED;
                            }
                            if (s5 !== peg$FAILED) {
                                if (input
                                    .substr(peg$currPos, 3)
                                    .toLowerCase() === peg$c6) {
                                    s6 = input.substr(peg$currPos, 3);
                                    peg$currPos += 3;
                                }
                                else {
                                    s6 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$c7);
                                    }
                                }
                                if (s6 === peg$FAILED) {
                                    if (input.substr(peg$currPos, 3) === peg$c8) {
                                        s6 = peg$c8;
                                        peg$currPos += 3;
                                    }
                                    else {
                                        s6 = peg$FAILED;
                                        if (peg$silentFails === 0) {
                                            peg$fail(peg$c9);
                                        }
                                    }
                                }
                                if (s6 !== peg$FAILED) {
                                    s7 = [];
                                    s8 = peg$parseSPACE_SYMBOL();
                                    if (s8 !== peg$FAILED) {
                                        while (s8 !== peg$FAILED) {
                                            s7.push(s8);
                                            s8 = peg$parseSPACE_SYMBOL();
                                        }
                                    }
                                    else {
                                        s7 = peg$FAILED;
                                    }
                                    if (s7 !== peg$FAILED) {
                                        s8 = peg$parseDATE_STRING();
                                        if (s8 !== peg$FAILED) {
                                            peg$savedPos = s0;
                                            s1 = peg$c10(s4, s8);
                                            s0 = s1;
                                        }
                                        else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    }
                                    else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                }
                                else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseBETWEEN_NUMERICAL() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseSPACE_SYMBOL();
            while (s2 !== peg$FAILED) {
                s1.push(s2);
                s2 = peg$parseSPACE_SYMBOL();
            }
            if (s1 !== peg$FAILED) {
                if (input.substr(peg$currPos, 7).toLowerCase() === peg$c2) {
                    s2 = input.substr(peg$currPos, 7);
                    peg$currPos += 7;
                }
                else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c3);
                    }
                }
                if (s2 === peg$FAILED) {
                    if (input.substr(peg$currPos, 7) === peg$c4) {
                        s2 = peg$c4;
                        peg$currPos += 7;
                    }
                    else {
                        s2 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c5);
                        }
                    }
                }
                if (s2 !== peg$FAILED) {
                    s3 = [];
                    s4 = peg$parseSPACE_SYMBOL();
                    if (s4 !== peg$FAILED) {
                        while (s4 !== peg$FAILED) {
                            s3.push(s4);
                            s4 = peg$parseSPACE_SYMBOL();
                        }
                    }
                    else {
                        s3 = peg$FAILED;
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parseNUMBER();
                        if (s4 !== peg$FAILED) {
                            s5 = [];
                            s6 = peg$parseSPACE_SYMBOL();
                            if (s6 !== peg$FAILED) {
                                while (s6 !== peg$FAILED) {
                                    s5.push(s6);
                                    s6 = peg$parseSPACE_SYMBOL();
                                }
                            }
                            else {
                                s5 = peg$FAILED;
                            }
                            if (s5 !== peg$FAILED) {
                                if (input
                                    .substr(peg$currPos, 3)
                                    .toLowerCase() === peg$c6) {
                                    s6 = input.substr(peg$currPos, 3);
                                    peg$currPos += 3;
                                }
                                else {
                                    s6 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$c7);
                                    }
                                }
                                if (s6 === peg$FAILED) {
                                    if (input.substr(peg$currPos, 3) === peg$c8) {
                                        s6 = peg$c8;
                                        peg$currPos += 3;
                                    }
                                    else {
                                        s6 = peg$FAILED;
                                        if (peg$silentFails === 0) {
                                            peg$fail(peg$c9);
                                        }
                                    }
                                }
                                if (s6 !== peg$FAILED) {
                                    s7 = [];
                                    s8 = peg$parseSPACE_SYMBOL();
                                    if (s8 !== peg$FAILED) {
                                        while (s8 !== peg$FAILED) {
                                            s7.push(s8);
                                            s8 = peg$parseSPACE_SYMBOL();
                                        }
                                    }
                                    else {
                                        s7 = peg$FAILED;
                                    }
                                    if (s7 !== peg$FAILED) {
                                        s8 = peg$parseNUMBER();
                                        if (s8 !== peg$FAILED) {
                                            peg$savedPos = s0;
                                            s1 = peg$c10(s4, s8);
                                            s0 = s1;
                                        }
                                        else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    }
                                    else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                }
                                else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseNUMERICAL() {
            var s0, s1, s2, s3, s4;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseSPACE_SYMBOL();
            while (s2 !== peg$FAILED) {
                s1.push(s2);
                s2 = peg$parseSPACE_SYMBOL();
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parseOPERATOR();
                if (s2 !== peg$FAILED) {
                    s3 = [];
                    s4 = peg$parseSPACE_SYMBOL();
                    while (s4 !== peg$FAILED) {
                        s3.push(s4);
                        s4 = peg$parseSPACE_SYMBOL();
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parseNUMBER();
                        if (s4 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c11(s2, s4);
                            s0 = s1;
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseOPERATOR() {
            var s0;
            if (input.substr(peg$currPos, 2) === peg$c12) {
                s0 = peg$c12;
                peg$currPos += 2;
            }
            else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c13);
                }
            }
            if (s0 === peg$FAILED) {
                if (input.substr(peg$currPos, 2) === peg$c14) {
                    s0 = peg$c14;
                    peg$currPos += 2;
                }
                else {
                    s0 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c15);
                    }
                }
                if (s0 === peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 62) {
                        s0 = peg$c16;
                        peg$currPos++;
                    }
                    else {
                        s0 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c17);
                        }
                    }
                    if (s0 === peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 60) {
                            s0 = peg$c18;
                            peg$currPos++;
                        }
                        else {
                            s0 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c19);
                            }
                        }
                    }
                }
            }
            return s0;
        }
        function peg$parseDATE_STRING() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            s1 = peg$parsequotation_mark();
            if (s1 !== peg$FAILED) {
                s2 = peg$parseISO_DATE();
                if (s2 !== peg$FAILED) {
                    s3 = peg$parsequotation_mark();
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c20(s2);
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$parseISO_DATE();
            }
            return s0;
        }
        function peg$parseISO_DATE() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
            s0 = peg$currPos;
            s1 = peg$parseYEAR();
            if (s1 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 45) {
                    s2 = peg$c21;
                    peg$currPos++;
                }
                else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c22);
                    }
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parseMONTH();
                    if (s3 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 45) {
                            s4 = peg$c21;
                            peg$currPos++;
                        }
                        else {
                            s4 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c22);
                            }
                        }
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parseDAY();
                            if (s5 !== peg$FAILED) {
                                s6 = peg$currPos;
                                if (input.charCodeAt(peg$currPos) === 84) {
                                    s7 = peg$c23;
                                    peg$currPos++;
                                }
                                else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$c24);
                                    }
                                }
                                if (s7 !== peg$FAILED) {
                                    s8 = peg$parseTIME();
                                    if (s8 !== peg$FAILED) {
                                        if (input.charCodeAt(peg$currPos) === 90) {
                                            s9 = peg$c25;
                                            peg$currPos++;
                                        }
                                        else {
                                            s9 = peg$FAILED;
                                            if (peg$silentFails === 0) {
                                                peg$fail(peg$c26);
                                            }
                                        }
                                        if (s9 === peg$FAILED) {
                                            s9 = null;
                                        }
                                        if (s9 !== peg$FAILED) {
                                            s7 = [s7, s8, s9];
                                            s6 = s7;
                                        }
                                        else {
                                            peg$currPos = s6;
                                            s6 = peg$FAILED;
                                        }
                                    }
                                    else {
                                        peg$currPos = s6;
                                        s6 = peg$FAILED;
                                    }
                                }
                                else {
                                    peg$currPos = s6;
                                    s6 = peg$FAILED;
                                }
                                if (s6 === peg$FAILED) {
                                    s6 = null;
                                }
                                if (s6 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c27(s1, s3, s5, s6);
                                    s0 = s1;
                                }
                                else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseYEAR() {
            var s0, s1, s2, s3, s4;
            s0 = peg$currPos;
            if (peg$c28.test(input.charAt(peg$currPos))) {
                s1 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c29);
                }
            }
            if (s1 !== peg$FAILED) {
                if (peg$c28.test(input.charAt(peg$currPos))) {
                    s2 = input.charAt(peg$currPos);
                    peg$currPos++;
                }
                else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c29);
                    }
                }
                if (s2 !== peg$FAILED) {
                    if (peg$c28.test(input.charAt(peg$currPos))) {
                        s3 = input.charAt(peg$currPos);
                        peg$currPos++;
                    }
                    else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c29);
                        }
                    }
                    if (s3 !== peg$FAILED) {
                        if (peg$c28.test(input.charAt(peg$currPos))) {
                            s4 = input.charAt(peg$currPos);
                            peg$currPos++;
                        }
                        else {
                            s4 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c29);
                            }
                        }
                        if (s4 !== peg$FAILED) {
                            s1 = [s1, s2, s3, s4];
                            s0 = s1;
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseMONTH() {
            var s0, s1, s2;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 48) {
                s1 = peg$c30;
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c31);
                }
            }
            if (s1 !== peg$FAILED) {
                if (peg$c32.test(input.charAt(peg$currPos))) {
                    s2 = input.charAt(peg$currPos);
                    peg$currPos++;
                }
                else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c33);
                    }
                }
                if (s2 !== peg$FAILED) {
                    s1 = [s1, s2];
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.charCodeAt(peg$currPos) === 49) {
                    s1 = peg$c34;
                    peg$currPos++;
                }
                else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c35);
                    }
                }
                if (s1 !== peg$FAILED) {
                    if (peg$c36.test(input.charAt(peg$currPos))) {
                        s2 = input.charAt(peg$currPos);
                        peg$currPos++;
                    }
                    else {
                        s2 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c37);
                        }
                    }
                    if (s2 !== peg$FAILED) {
                        s1 = [s1, s2];
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            return s0;
        }
        function peg$parseDAY() {
            var s0, s1, s2;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 48) {
                s1 = peg$c30;
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c31);
                }
            }
            if (s1 !== peg$FAILED) {
                if (peg$c32.test(input.charAt(peg$currPos))) {
                    s2 = input.charAt(peg$currPos);
                    peg$currPos++;
                }
                else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c33);
                    }
                }
                if (s2 !== peg$FAILED) {
                    s1 = [s1, s2];
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (peg$c38.test(input.charAt(peg$currPos))) {
                    s1 = input.charAt(peg$currPos);
                    peg$currPos++;
                }
                else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c39);
                    }
                }
                if (s1 !== peg$FAILED) {
                    if (peg$c28.test(input.charAt(peg$currPos))) {
                        s2 = input.charAt(peg$currPos);
                        peg$currPos++;
                    }
                    else {
                        s2 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c29);
                        }
                    }
                    if (s2 !== peg$FAILED) {
                        s1 = [s1, s2];
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
                if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    if (input.charCodeAt(peg$currPos) === 51) {
                        s1 = peg$c40;
                        peg$currPos++;
                    }
                    else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c41);
                        }
                    }
                    if (s1 !== peg$FAILED) {
                        if (peg$c42.test(input.charAt(peg$currPos))) {
                            s2 = input.charAt(peg$currPos);
                            peg$currPos++;
                        }
                        else {
                            s2 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c43);
                            }
                        }
                        if (s2 !== peg$FAILED) {
                            s1 = [s1, s2];
                            s0 = s1;
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
            }
            return s0;
        }
        function peg$parseTIME() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12;
            s0 = peg$currPos;
            if (peg$c28.test(input.charAt(peg$currPos))) {
                s1 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c29);
                }
            }
            if (s1 !== peg$FAILED) {
                if (peg$c28.test(input.charAt(peg$currPos))) {
                    s2 = input.charAt(peg$currPos);
                    peg$currPos++;
                }
                else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c29);
                    }
                }
                if (s2 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 58) {
                        s3 = peg$c44;
                        peg$currPos++;
                    }
                    else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c45);
                        }
                    }
                    if (s3 !== peg$FAILED) {
                        if (peg$c28.test(input.charAt(peg$currPos))) {
                            s4 = input.charAt(peg$currPos);
                            peg$currPos++;
                        }
                        else {
                            s4 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c29);
                            }
                        }
                        if (s4 !== peg$FAILED) {
                            if (peg$c28.test(input.charAt(peg$currPos))) {
                                s5 = input.charAt(peg$currPos);
                                peg$currPos++;
                            }
                            else {
                                s5 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$c29);
                                }
                            }
                            if (s5 !== peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 58) {
                                    s6 = peg$c44;
                                    peg$currPos++;
                                }
                                else {
                                    s6 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$c45);
                                    }
                                }
                                if (s6 !== peg$FAILED) {
                                    if (peg$c28.test(input.charAt(peg$currPos))) {
                                        s7 = input.charAt(peg$currPos);
                                        peg$currPos++;
                                    }
                                    else {
                                        s7 = peg$FAILED;
                                        if (peg$silentFails === 0) {
                                            peg$fail(peg$c29);
                                        }
                                    }
                                    if (s7 !== peg$FAILED) {
                                        if (peg$c28.test(input.charAt(peg$currPos))) {
                                            s8 = input.charAt(peg$currPos);
                                            peg$currPos++;
                                        }
                                        else {
                                            s8 = peg$FAILED;
                                            if (peg$silentFails === 0) {
                                                peg$fail(peg$c29);
                                            }
                                        }
                                        if (s8 !== peg$FAILED) {
                                            s9 = peg$currPos;
                                            if (input.charCodeAt(peg$currPos) === 46) {
                                                s10 = peg$c46;
                                                peg$currPos++;
                                            }
                                            else {
                                                s10 = peg$FAILED;
                                                if (peg$silentFails === 0) {
                                                    peg$fail(peg$c47);
                                                }
                                            }
                                            if (s10 !== peg$FAILED) {
                                                s11 = [];
                                                if (peg$c28.test(input.charAt(peg$currPos))) {
                                                    s12 =
                                                        input.charAt(peg$currPos);
                                                    peg$currPos++;
                                                }
                                                else {
                                                    s12 = peg$FAILED;
                                                    if (peg$silentFails === 0) {
                                                        peg$fail(peg$c29);
                                                    }
                                                }
                                                if (s12 !== peg$FAILED) {
                                                    while (s12 !== peg$FAILED) {
                                                        s11.push(s12);
                                                        if (peg$c28.test(input.charAt(peg$currPos))) {
                                                            s12 =
                                                                input.charAt(peg$currPos);
                                                            peg$currPos++;
                                                        }
                                                        else {
                                                            s12 = peg$FAILED;
                                                            if (peg$silentFails ===
                                                                0) {
                                                                peg$fail(peg$c29);
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    s11 = peg$FAILED;
                                                }
                                                if (s11 !== peg$FAILED) {
                                                    s10 = [s10, s11];
                                                    s9 = s10;
                                                }
                                                else {
                                                    peg$currPos = s9;
                                                    s9 = peg$FAILED;
                                                }
                                            }
                                            else {
                                                peg$currPos = s9;
                                                s9 = peg$FAILED;
                                            }
                                            if (s9 === peg$FAILED) {
                                                s9 = null;
                                            }
                                            if (s9 !== peg$FAILED) {
                                                s1 = [
                                                    s1,
                                                    s2,
                                                    s3,
                                                    s4,
                                                    s5,
                                                    s6,
                                                    s7,
                                                    s8,
                                                    s9,
                                                ];
                                                s0 = s1;
                                            }
                                            else {
                                                peg$currPos = s0;
                                                s0 = peg$FAILED;
                                            }
                                        }
                                        else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    }
                                    else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                }
                                else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseDATE_RESTRICTION() {
            var s0, s1, s2, s3, s4, s5, s6;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseSPACE_SYMBOL();
            while (s2 !== peg$FAILED) {
                s1.push(s2);
                s2 = peg$parseSPACE_SYMBOL();
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parseDATE_OPERATOR();
                if (s2 !== peg$FAILED) {
                    s3 = [];
                    s4 = peg$parseSPACE_SYMBOL();
                    while (s4 !== peg$FAILED) {
                        s3.push(s4);
                        s4 = peg$parseSPACE_SYMBOL();
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parseNUMBER();
                        if (s4 !== peg$FAILED) {
                            s5 = [];
                            s6 = peg$parseSPACE_SYMBOL();
                            while (s6 !== peg$FAILED) {
                                s5.push(s6);
                                s6 = peg$parseSPACE_SYMBOL();
                            }
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parseDATE_INTERVAL();
                                if (s6 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c48(s2, s4, s6);
                                    s0 = s1;
                                }
                                else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseDATE_OPERATOR() {
            var s0;
            if (input.substr(peg$currPos, 9) === peg$c49) {
                s0 = peg$c49;
                peg$currPos += 9;
            }
            else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c50);
                }
            }
            if (s0 === peg$FAILED) {
                if (input.substr(peg$currPos, 9) === peg$c51) {
                    s0 = peg$c51;
                    peg$currPos += 9;
                }
                else {
                    s0 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c52);
                    }
                }
            }
            return s0;
        }
        function peg$parseDATE_INTERVAL() {
            var s0;
            if (input.substr(peg$currPos, 12) === peg$c53) {
                s0 = peg$c53;
                peg$currPos += 12;
            }
            else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c54);
                }
            }
            if (s0 === peg$FAILED) {
                if (input.substr(peg$currPos, 7) === peg$c55) {
                    s0 = peg$c55;
                    peg$currPos += 7;
                }
                else {
                    s0 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c56);
                    }
                }
                if (s0 === peg$FAILED) {
                    if (input.substr(peg$currPos, 7) === peg$c57) {
                        s0 = peg$c57;
                        peg$currPos += 7;
                    }
                    else {
                        s0 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c58);
                        }
                    }
                    if (s0 === peg$FAILED) {
                        if (input.substr(peg$currPos, 5) === peg$c59) {
                            s0 = peg$c59;
                            peg$currPos += 5;
                        }
                        else {
                            s0 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c60);
                            }
                        }
                        if (s0 === peg$FAILED) {
                            if (input.substr(peg$currPos, 4) === peg$c61) {
                                s0 = peg$c61;
                                peg$currPos += 4;
                            }
                            else {
                                s0 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$c62);
                                }
                            }
                            if (s0 === peg$FAILED) {
                                if (input.substr(peg$currPos, 5) === peg$c63) {
                                    s0 = peg$c63;
                                    peg$currPos += 5;
                                }
                                else {
                                    s0 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$c64);
                                    }
                                }
                                if (s0 === peg$FAILED) {
                                    if (input.substr(peg$currPos, 6) === peg$c65) {
                                        s0 = peg$c65;
                                        peg$currPos += 6;
                                    }
                                    else {
                                        s0 = peg$FAILED;
                                        if (peg$silentFails === 0) {
                                            peg$fail(peg$c66);
                                        }
                                    }
                                    if (s0 === peg$FAILED) {
                                        if (input.substr(peg$currPos, 5) ===
                                            peg$c67) {
                                            s0 = peg$c67;
                                            peg$currPos += 5;
                                        }
                                        else {
                                            s0 = peg$FAILED;
                                            if (peg$silentFails === 0) {
                                                peg$fail(peg$c68);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return s0;
        }
        function peg$parseCURRENT_DATE_RESTRICTION() {
            var s0, s1, s2, s3, s4;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseSPACE_SYMBOL();
            while (s2 !== peg$FAILED) {
                s1.push(s2);
                s2 = peg$parseSPACE_SYMBOL();
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parseCURRENT_DATE_OPERATOR();
                if (s2 !== peg$FAILED) {
                    s3 = [];
                    s4 = peg$parseSPACE_SYMBOL();
                    if (s4 !== peg$FAILED) {
                        while (s4 !== peg$FAILED) {
                            s3.push(s4);
                            s4 = peg$parseSPACE_SYMBOL();
                        }
                    }
                    else {
                        s3 = peg$FAILED;
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parseCURRENT_DATE_INTERVAL();
                        if (s4 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c69(s2, s4);
                            s0 = s1;
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseCURRENT_DATE_OPERATOR() {
            var s0;
            if (input.substr(peg$currPos, 15) === peg$c70) {
                s0 = peg$c70;
                peg$currPos += 15;
            }
            else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c71);
                }
            }
            if (s0 === peg$FAILED) {
                if (input.substr(peg$currPos, 12) === peg$c72) {
                    s0 = peg$c72;
                    peg$currPos += 12;
                }
                else {
                    s0 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c73);
                    }
                }
            }
            return s0;
        }
        function peg$parseCURRENT_DATE_INTERVAL() {
            var s0, s1;
            if (input.substr(peg$currPos, 12) === peg$c53) {
                s0 = peg$c53;
                peg$currPos += 12;
            }
            else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c54);
                }
            }
            if (s0 === peg$FAILED) {
                if (input.substr(peg$currPos, 7) === peg$c55) {
                    s0 = peg$c55;
                    peg$currPos += 7;
                }
                else {
                    s0 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c56);
                    }
                }
                if (s0 === peg$FAILED) {
                    if (input.substr(peg$currPos, 7) === peg$c57) {
                        s0 = peg$c57;
                        peg$currPos += 7;
                    }
                    else {
                        s0 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c58);
                        }
                    }
                    if (s0 === peg$FAILED) {
                        if (input.substr(peg$currPos, 5) === peg$c59) {
                            s0 = peg$c59;
                            peg$currPos += 5;
                        }
                        else {
                            s0 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c60);
                            }
                        }
                        if (s0 === peg$FAILED) {
                            if (input.substr(peg$currPos, 4) === peg$c61) {
                                s0 = peg$c61;
                                peg$currPos += 4;
                            }
                            else {
                                s0 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$c62);
                                }
                            }
                            if (s0 === peg$FAILED) {
                                if (input.substr(peg$currPos, 5) === peg$c63) {
                                    s0 = peg$c63;
                                    peg$currPos += 5;
                                }
                                else {
                                    s0 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$c64);
                                    }
                                }
                                if (s0 === peg$FAILED) {
                                    if (input.substr(peg$currPos, 6) === peg$c65) {
                                        s0 = peg$c65;
                                        peg$currPos += 6;
                                    }
                                    else {
                                        s0 = peg$FAILED;
                                        if (peg$silentFails === 0) {
                                            peg$fail(peg$c66);
                                        }
                                    }
                                    if (s0 === peg$FAILED) {
                                        if (input.substr(peg$currPos, 8) ===
                                            peg$c74) {
                                            s0 = peg$c74;
                                            peg$currPos += 8;
                                        }
                                        else {
                                            s0 = peg$FAILED;
                                            if (peg$silentFails === 0) {
                                                peg$fail(peg$c75);
                                            }
                                        }
                                        if (s0 === peg$FAILED) {
                                            if (input.substr(peg$currPos, 5) ===
                                                peg$c67) {
                                                s0 = peg$c67;
                                                peg$currPos += 5;
                                            }
                                            else {
                                                s0 = peg$FAILED;
                                                if (peg$silentFails === 0) {
                                                    peg$fail(peg$c68);
                                                }
                                            }
                                            if (s0 === peg$FAILED) {
                                                s0 = peg$currPos;
                                                if (input.substr(peg$currPos, 11) === peg$c76) {
                                                    s1 = peg$c76;
                                                    peg$currPos += 11;
                                                }
                                                else {
                                                    s1 = peg$FAILED;
                                                    if (peg$silentFails === 0) {
                                                        peg$fail(peg$c77);
                                                    }
                                                }
                                                if (s1 === peg$FAILED) {
                                                    if (input.substr(peg$currPos, 6) === peg$c78) {
                                                        s1 = peg$c78;
                                                        peg$currPos += 6;
                                                    }
                                                    else {
                                                        s1 = peg$FAILED;
                                                        if (peg$silentFails ===
                                                            0) {
                                                            peg$fail(peg$c79);
                                                        }
                                                    }
                                                    if (s1 === peg$FAILED) {
                                                        if (input.substr(peg$currPos, 6) === peg$c80) {
                                                            s1 = peg$c80;
                                                            peg$currPos += 6;
                                                        }
                                                        else {
                                                            s1 = peg$FAILED;
                                                            if (peg$silentFails ===
                                                                0) {
                                                                peg$fail(peg$c81);
                                                            }
                                                        }
                                                        if (s1 === peg$FAILED) {
                                                            if (input.substr(peg$currPos, 4) === peg$c82) {
                                                                s1 = peg$c82;
                                                                peg$currPos += 4;
                                                            }
                                                            else {
                                                                s1 = peg$FAILED;
                                                                if (peg$silentFails ===
                                                                    0) {
                                                                    peg$fail(peg$c83);
                                                                }
                                                            }
                                                            if (s1 ===
                                                                peg$FAILED) {
                                                                if (input.substr(peg$currPos, 3) ===
                                                                    peg$c84) {
                                                                    s1 =
                                                                        peg$c84;
                                                                    peg$currPos += 3;
                                                                }
                                                                else {
                                                                    s1 =
                                                                        peg$FAILED;
                                                                    if (peg$silentFails ===
                                                                        0) {
                                                                        peg$fail(peg$c85);
                                                                    }
                                                                }
                                                                if (s1 ===
                                                                    peg$FAILED) {
                                                                    if (input.substr(peg$currPos, 4) ===
                                                                        peg$c86) {
                                                                        s1 =
                                                                            peg$c86;
                                                                        peg$currPos += 4;
                                                                    }
                                                                    else {
                                                                        s1 =
                                                                            peg$FAILED;
                                                                        if (peg$silentFails ===
                                                                            0) {
                                                                            peg$fail(peg$c87);
                                                                        }
                                                                    }
                                                                    if (s1 ===
                                                                        peg$FAILED) {
                                                                        if (input.substr(peg$currPos, 5) ===
                                                                            peg$c88) {
                                                                            s1 =
                                                                                peg$c88;
                                                                            peg$currPos += 5;
                                                                        }
                                                                        else {
                                                                            s1 =
                                                                                peg$FAILED;
                                                                            if (peg$silentFails ===
                                                                                0) {
                                                                                peg$fail(peg$c89);
                                                                            }
                                                                        }
                                                                        if (s1 ===
                                                                            peg$FAILED) {
                                                                            if (input.substr(peg$currPos, 7) ===
                                                                                peg$c90) {
                                                                                s1 =
                                                                                    peg$c90;
                                                                                peg$currPos += 7;
                                                                            }
                                                                            else {
                                                                                s1 =
                                                                                    peg$FAILED;
                                                                                if (peg$silentFails ===
                                                                                    0) {
                                                                                    peg$fail(peg$c91);
                                                                                }
                                                                            }
                                                                            if (s1 ===
                                                                                peg$FAILED) {
                                                                                if (input.substr(peg$currPos, 4) ===
                                                                                    peg$c92) {
                                                                                    s1 =
                                                                                        peg$c92;
                                                                                    peg$currPos += 4;
                                                                                }
                                                                                else {
                                                                                    s1 =
                                                                                        peg$FAILED;
                                                                                    if (peg$silentFails ===
                                                                                        0) {
                                                                                        peg$fail(peg$c93);
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                if (s1 !== peg$FAILED) {
                                                    peg$savedPos = s0;
                                                    s1 = peg$c94(s1);
                                                }
                                                s0 = s1;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return s0;
        }
        function peg$parseNUMBER() {
            var s0, s1, s2, s3, s4, s5, s6;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 45) {
                s1 = peg$c21;
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c22);
                }
            }
            if (s1 === peg$FAILED) {
                s1 = null;
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parseFLOAT();
                if (s2 !== peg$FAILED) {
                    s3 = peg$currPos;
                    if (peg$c95.test(input.charAt(peg$currPos))) {
                        s4 = input.charAt(peg$currPos);
                        peg$currPos++;
                    }
                    else {
                        s4 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c96);
                        }
                    }
                    if (s4 !== peg$FAILED) {
                        if (peg$c97.test(input.charAt(peg$currPos))) {
                            s5 = input.charAt(peg$currPos);
                            peg$currPos++;
                        }
                        else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c98);
                            }
                        }
                        if (s5 === peg$FAILED) {
                            s5 = null;
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parseINTEGER();
                            if (s6 !== peg$FAILED) {
                                s4 = [s4, s5, s6];
                                s3 = s4;
                            }
                            else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                    if (s3 === peg$FAILED) {
                        s3 = null;
                    }
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c99();
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseFLOAT() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            s1 = peg$parseINTEGER();
            if (s1 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 46) {
                    s2 = peg$c46;
                    peg$currPos++;
                }
                else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c47);
                    }
                }
                if (s2 === peg$FAILED) {
                    s2 = null;
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parseINTEGER();
                    if (s3 === peg$FAILED) {
                        s3 = null;
                    }
                    if (s3 !== peg$FAILED) {
                        s1 = [s1, s2, s3];
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseINTEGER() {
            var s0, s1;
            s0 = [];
            if (peg$c28.test(input.charAt(peg$currPos))) {
                s1 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c29);
                }
            }
            if (s1 !== peg$FAILED) {
                while (s1 !== peg$FAILED) {
                    s0.push(s1);
                    if (peg$c28.test(input.charAt(peg$currPos))) {
                        s1 = input.charAt(peg$currPos);
                        peg$currPos++;
                    }
                    else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c29);
                        }
                    }
                }
            }
            else {
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseLIST() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            s1 = peg$parseTERM();
            if (s1 !== peg$FAILED) {
                s2 = peg$parseCOMMA_SYMBOL();
                if (s2 !== peg$FAILED) {
                    s3 = peg$parseEXPRESSION();
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c100(s1, s3);
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseTERM() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = peg$parseNOT();
            if (s1 === peg$FAILED) {
                s1 = null;
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parsePCT();
                if (s2 === peg$FAILED) {
                    s2 = peg$parseKEYWORDS();
                    if (s2 === peg$FAILED) {
                        s2 = peg$parseMATCH();
                    }
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c101(s1, s2);
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseKEYWORDS() {
            var s0, s1;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 5) === peg$c102) {
                s1 = peg$c102;
                peg$currPos += 5;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c103);
                }
            }
            if (s1 === peg$FAILED) {
                if (input.substr(peg$currPos, 5) === peg$c104) {
                    s1 = peg$c104;
                    peg$currPos += 5;
                }
                else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c105);
                    }
                }
            }
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c106();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 4) === peg$c107) {
                    s1 = peg$c107;
                    peg$currPos += 4;
                }
                else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c108);
                    }
                }
                if (s1 === peg$FAILED) {
                    if (input.substr(peg$currPos, 4) === peg$c109) {
                        s1 = peg$c109;
                        peg$currPos += 4;
                    }
                    else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c110);
                        }
                    }
                }
                if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c111();
                }
                s0 = s1;
            }
            return s0;
        }
        function peg$parseMATCH() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            s1 = peg$parsequotation_mark();
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$parsechar();
                if (s3 === peg$FAILED) {
                    s3 = peg$parseCOMMA_SYMBOL();
                    if (s3 === peg$FAILED) {
                        s3 = peg$parseUNDERSCORE();
                        if (s3 === peg$FAILED) {
                            s3 = peg$parseCARET();
                        }
                    }
                }
                if (s3 !== peg$FAILED) {
                    while (s3 !== peg$FAILED) {
                        s2.push(s3);
                        s3 = peg$parsechar();
                        if (s3 === peg$FAILED) {
                            s3 = peg$parseCOMMA_SYMBOL();
                            if (s3 === peg$FAILED) {
                                s3 = peg$parseUNDERSCORE();
                                if (s3 === peg$FAILED) {
                                    s3 = peg$parseCARET();
                                }
                            }
                        }
                    }
                }
                else {
                    s2 = peg$FAILED;
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parsequotation_mark();
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c112(s2);
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = [];
                s2 = peg$parsechar();
                if (s2 === peg$FAILED) {
                    s2 = peg$parseCOMMA_SYMBOL();
                    if (s2 === peg$FAILED) {
                        s2 = peg$parseUNDERSCORE();
                        if (s2 === peg$FAILED) {
                            s2 = peg$parseCARET();
                        }
                    }
                }
                if (s2 !== peg$FAILED) {
                    while (s2 !== peg$FAILED) {
                        s1.push(s2);
                        s2 = peg$parsechar();
                        if (s2 === peg$FAILED) {
                            s2 = peg$parseCOMMA_SYMBOL();
                            if (s2 === peg$FAILED) {
                                s2 = peg$parseUNDERSCORE();
                                if (s2 === peg$FAILED) {
                                    s2 = peg$parseCARET();
                                }
                            }
                        }
                    }
                }
                else {
                    s1 = peg$FAILED;
                }
                if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c113(s1);
                }
                s0 = s1;
            }
            return s0;
        }
        function peg$parsePCT() {
            var s0;
            s0 = peg$parseCONTAINS();
            if (s0 === peg$FAILED) {
                s0 = peg$parseSTARTS_WITH();
                if (s0 === peg$FAILED) {
                    s0 = peg$parseENDS_WITH();
                }
            }
            return s0;
        }
        function peg$parseCONTAINS() {
            var s0, s1, s2, s3, s4, s5;
            s0 = peg$currPos;
            s1 = peg$parsePCT_SYMBOL();
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$parsechar();
                if (s3 === peg$FAILED) {
                    s3 = peg$parseUNDERSCORE();
                }
                if (s3 !== peg$FAILED) {
                    while (s3 !== peg$FAILED) {
                        s2.push(s3);
                        s3 = peg$parsechar();
                        if (s3 === peg$FAILED) {
                            s3 = peg$parseUNDERSCORE();
                        }
                    }
                }
                else {
                    s2 = peg$FAILED;
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parsePCT_SYMBOL();
                    if (s3 !== peg$FAILED) {
                        s4 = peg$currPos;
                        peg$silentFails++;
                        s5 = peg$parsestring();
                        if (s5 === peg$FAILED) {
                            s5 = peg$parsePCT_SYMBOL();
                            if (s5 === peg$FAILED) {
                                s5 = peg$parseUNDERSCORE();
                            }
                        }
                        peg$silentFails--;
                        if (s5 === peg$FAILED) {
                            s4 = void 0;
                        }
                        else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                        if (s4 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c114(s2);
                            s0 = s1;
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseSTARTS_WITH() {
            var s0, s1, s2, s3, s4;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parsechar();
            if (s2 === peg$FAILED) {
                s2 = peg$parseUNDERSCORE();
            }
            if (s2 !== peg$FAILED) {
                while (s2 !== peg$FAILED) {
                    s1.push(s2);
                    s2 = peg$parsechar();
                    if (s2 === peg$FAILED) {
                        s2 = peg$parseUNDERSCORE();
                    }
                }
            }
            else {
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parsePCT_SYMBOL();
                if (s2 !== peg$FAILED) {
                    s3 = peg$currPos;
                    peg$silentFails++;
                    s4 = peg$parsestring();
                    if (s4 === peg$FAILED) {
                        s4 = peg$parsePCT_SYMBOL();
                        if (s4 === peg$FAILED) {
                            s4 = peg$parseUNDERSCORE();
                        }
                    }
                    peg$silentFails--;
                    if (s4 === peg$FAILED) {
                        s3 = void 0;
                    }
                    else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c115(s1);
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseENDS_WITH() {
            var s0, s1, s2, s3, s4;
            s0 = peg$currPos;
            s1 = peg$parsePCT_SYMBOL();
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$parsechar();
                if (s3 === peg$FAILED) {
                    s3 = peg$parseUNDERSCORE();
                }
                if (s3 !== peg$FAILED) {
                    while (s3 !== peg$FAILED) {
                        s2.push(s3);
                        s3 = peg$parsechar();
                        if (s3 === peg$FAILED) {
                            s3 = peg$parseUNDERSCORE();
                        }
                    }
                }
                else {
                    s2 = peg$FAILED;
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$currPos;
                    peg$silentFails++;
                    s4 = peg$parsePCT_SYMBOL();
                    peg$silentFails--;
                    if (s4 === peg$FAILED) {
                        s3 = void 0;
                    }
                    else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c116(s2);
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseNOT() {
            var s0;
            if (input.charCodeAt(peg$currPos) === 33) {
                s0 = peg$c117;
                peg$currPos++;
            }
            else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c118);
                }
            }
            return s0;
        }
        function peg$parseraw_string() {
            var s0, s1;
            peg$silentFails++;
            s0 = peg$currPos;
            s1 = peg$parsechar_sequence();
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c120(s1);
            }
            s0 = s1;
            peg$silentFails--;
            if (s0 === peg$FAILED) {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c119);
                }
            }
            return s0;
        }
        function peg$parsestring() {
            var s0, s1;
            peg$silentFails++;
            s0 = peg$currPos;
            s1 = peg$parsechar_sequence();
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c121(s1);
            }
            s0 = s1;
            peg$silentFails--;
            if (s0 === peg$FAILED) {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c119);
                }
            }
            return s0;
        }
        function peg$parsechar_sequence() {
            var s0, s1, s2, s3;
            peg$silentFails++;
            s0 = peg$currPos;
            s1 = peg$parsequotation_mark();
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$parsevalid_char();
                if (s3 === peg$FAILED) {
                    s3 = peg$parseescaped_quotation_mark();
                }
                while (s3 !== peg$FAILED) {
                    s2.push(s3);
                    s3 = peg$parsevalid_char();
                    if (s3 === peg$FAILED) {
                        s3 = peg$parseescaped_quotation_mark();
                    }
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parsequotation_mark();
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c122(s2);
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = [];
                s2 = peg$parsechar();
                if (s2 !== peg$FAILED) {
                    while (s2 !== peg$FAILED) {
                        s1.push(s2);
                        s2 = peg$parsechar();
                    }
                }
                else {
                    s1 = peg$FAILED;
                }
                if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c123(s1);
                }
                s0 = s1;
            }
            peg$silentFails--;
            if (s0 === peg$FAILED) {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c119);
                }
            }
            return s0;
        }
        function peg$parsechar() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
            peg$silentFails++;
            s0 = peg$parseESCAPE_CARET();
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parseescape();
                if (s1 !== peg$FAILED) {
                    s2 = peg$parseSYMBOLS();
                    if (s2 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c125(s2);
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
                if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    s1 = peg$parseescape();
                    if (s1 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 34) {
                            s2 = peg$c126;
                            peg$currPos++;
                        }
                        else {
                            s2 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c127);
                            }
                        }
                        if (s2 === peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 92) {
                                s2 = peg$c128;
                                peg$currPos++;
                            }
                            else {
                                s2 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$c129);
                                }
                            }
                            if (s2 === peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 47) {
                                    s2 = peg$c130;
                                    peg$currPos++;
                                }
                                else {
                                    s2 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$c131);
                                    }
                                }
                                if (s2 === peg$FAILED) {
                                    s2 = peg$currPos;
                                    if (input.charCodeAt(peg$currPos) === 98) {
                                        s3 = peg$c132;
                                        peg$currPos++;
                                    }
                                    else {
                                        s3 = peg$FAILED;
                                        if (peg$silentFails === 0) {
                                            peg$fail(peg$c133);
                                        }
                                    }
                                    if (s3 !== peg$FAILED) {
                                        peg$savedPos = s2;
                                        s3 = peg$c134();
                                    }
                                    s2 = s3;
                                    if (s2 === peg$FAILED) {
                                        s2 = peg$currPos;
                                        if (input.charCodeAt(peg$currPos) ===
                                            102) {
                                            s3 = peg$c135;
                                            peg$currPos++;
                                        }
                                        else {
                                            s3 = peg$FAILED;
                                            if (peg$silentFails === 0) {
                                                peg$fail(peg$c136);
                                            }
                                        }
                                        if (s3 !== peg$FAILED) {
                                            peg$savedPos = s2;
                                            s3 = peg$c137();
                                        }
                                        s2 = s3;
                                        if (s2 === peg$FAILED) {
                                            s2 = peg$currPos;
                                            if (input.charCodeAt(peg$currPos) === 110) {
                                                s3 = peg$c138;
                                                peg$currPos++;
                                            }
                                            else {
                                                s3 = peg$FAILED;
                                                if (peg$silentFails === 0) {
                                                    peg$fail(peg$c139);
                                                }
                                            }
                                            if (s3 !== peg$FAILED) {
                                                peg$savedPos = s2;
                                                s3 = peg$c140();
                                            }
                                            s2 = s3;
                                            if (s2 === peg$FAILED) {
                                                s2 = peg$currPos;
                                                if (input.charCodeAt(peg$currPos) === 114) {
                                                    s3 = peg$c141;
                                                    peg$currPos++;
                                                }
                                                else {
                                                    s3 = peg$FAILED;
                                                    if (peg$silentFails === 0) {
                                                        peg$fail(peg$c142);
                                                    }
                                                }
                                                if (s3 !== peg$FAILED) {
                                                    peg$savedPos = s2;
                                                    s3 = peg$c143();
                                                }
                                                s2 = s3;
                                                if (s2 === peg$FAILED) {
                                                    s2 = peg$currPos;
                                                    if (input.charCodeAt(peg$currPos) === 116) {
                                                        s3 = peg$c144;
                                                        peg$currPos++;
                                                    }
                                                    else {
                                                        s3 = peg$FAILED;
                                                        if (peg$silentFails ===
                                                            0) {
                                                            peg$fail(peg$c145);
                                                        }
                                                    }
                                                    if (s3 !== peg$FAILED) {
                                                        peg$savedPos = s2;
                                                        s3 = peg$c146();
                                                    }
                                                    s2 = s3;
                                                    if (s2 === peg$FAILED) {
                                                        s2 = peg$currPos;
                                                        if (input.charCodeAt(peg$currPos) === 117) {
                                                            s3 = peg$c147;
                                                            peg$currPos++;
                                                        }
                                                        else {
                                                            s3 = peg$FAILED;
                                                            if (peg$silentFails ===
                                                                0) {
                                                                peg$fail(peg$c148);
                                                            }
                                                        }
                                                        if (s3 !== peg$FAILED) {
                                                            s4 = peg$currPos;
                                                            s5 = peg$currPos;
                                                            s6 =
                                                                peg$parseHEXDIG();
                                                            if (s6 !==
                                                                peg$FAILED) {
                                                                s7 =
                                                                    peg$parseHEXDIG();
                                                                if (s7 !==
                                                                    peg$FAILED) {
                                                                    s8 =
                                                                        peg$parseHEXDIG();
                                                                    if (s8 !==
                                                                        peg$FAILED) {
                                                                        s9 =
                                                                            peg$parseHEXDIG();
                                                                        if (s9 !==
                                                                            peg$FAILED) {
                                                                            s6 =
                                                                                [
                                                                                    s6,
                                                                                    s7,
                                                                                    s8,
                                                                                    s9,
                                                                                ];
                                                                            s5 =
                                                                                s6;
                                                                        }
                                                                        else {
                                                                            peg$currPos =
                                                                                s5;
                                                                            s5 =
                                                                                peg$FAILED;
                                                                        }
                                                                    }
                                                                    else {
                                                                        peg$currPos =
                                                                            s5;
                                                                        s5 =
                                                                            peg$FAILED;
                                                                    }
                                                                }
                                                                else {
                                                                    peg$currPos =
                                                                        s5;
                                                                    s5 =
                                                                        peg$FAILED;
                                                                }
                                                            }
                                                            else {
                                                                peg$currPos =
                                                                    s5;
                                                                s5 = peg$FAILED;
                                                            }
                                                            if (s5 !==
                                                                peg$FAILED) {
                                                                s4 =
                                                                    input.substring(s4, peg$currPos);
                                                            }
                                                            else {
                                                                s4 = s5;
                                                            }
                                                            if (s4 !==
                                                                peg$FAILED) {
                                                                peg$savedPos =
                                                                    s2;
                                                                s3 =
                                                                    peg$c149(s4);
                                                                s2 = s3;
                                                            }
                                                            else {
                                                                peg$currPos =
                                                                    s2;
                                                                s2 = peg$FAILED;
                                                            }
                                                        }
                                                        else {
                                                            peg$currPos = s2;
                                                            s2 = peg$FAILED;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        if (s2 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c150(s2);
                            s0 = s1;
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    if (s0 === peg$FAILED) {
                        s0 = peg$parseunescaped();
                        if (s0 === peg$FAILED) {
                            s0 = peg$parseNOT_SYMBOL();
                        }
                    }
                }
            }
            peg$silentFails--;
            if (s0 === peg$FAILED) {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c124);
                }
            }
            return s0;
        }
        function peg$parseESCAPE_CARET() {
            var s0, s1, s2, s3, s4, s5;
            s0 = peg$currPos;
            s1 = peg$parseCARET();
            if (s1 !== peg$FAILED) {
                s2 = peg$currPos;
                s3 = peg$parseSPACE_SYMBOL();
                if (s3 !== peg$FAILED) {
                    s4 = peg$currPos;
                    peg$silentFails++;
                    s5 = peg$parseFOLLOWING_SPACE_END();
                    peg$silentFails--;
                    if (s5 === peg$FAILED) {
                        s4 = void 0;
                    }
                    else {
                        peg$currPos = s4;
                        s4 = peg$FAILED;
                    }
                    if (s4 !== peg$FAILED) {
                        s3 = [s3, s4];
                        s2 = s3;
                    }
                    else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
                if (s2 === peg$FAILED) {
                    s2 = peg$parseESCAPED_DOUBLE_SPACE();
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c151();
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parseCARET();
                if (s1 !== peg$FAILED) {
                    s2 = peg$parsePCT_SYMBOL();
                    if (s2 === peg$FAILED) {
                        s2 = peg$parseUNDERSCORE();
                        if (s2 === peg$FAILED) {
                            s2 = peg$parseCOMMA_SYMBOL();
                            if (s2 === peg$FAILED) {
                                s2 = peg$parseCARET();
                                if (s2 === peg$FAILED) {
                                    s2 = peg$parseNOT_SYMBOL();
                                }
                            }
                        }
                    }
                    if (s2 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c152(s2);
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            return s0;
        }
        function peg$parseSYMBOLS() {
            var s0;
            s0 = peg$parsePCT_SYMBOL();
            if (s0 === peg$FAILED) {
                s0 = peg$parseCOMMA_SYMBOL();
                if (s0 === peg$FAILED) {
                    s0 = peg$parseNOT_SYMBOL();
                    if (s0 === peg$FAILED) {
                        s0 = peg$parseUNDERSCORE();
                        if (s0 === peg$FAILED) {
                            s0 = peg$parseCARET();
                        }
                    }
                }
            }
            return s0;
        }
        function peg$parsePCT_SYMBOL() {
            var s0;
            if (input.charCodeAt(peg$currPos) === 37) {
                s0 = peg$c153;
                peg$currPos++;
            }
            else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c154);
                }
            }
            return s0;
        }
        function peg$parseUNDERSCORE() {
            var s0;
            if (input.charCodeAt(peg$currPos) === 95) {
                s0 = peg$c155;
                peg$currPos++;
            }
            else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c156);
                }
            }
            return s0;
        }
        function peg$parseCOMMA_SYMBOL() {
            var s0;
            if (input.charCodeAt(peg$currPos) === 44) {
                s0 = peg$c157;
                peg$currPos++;
            }
            else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c158);
                }
            }
            return s0;
        }
        function peg$parseNOT_SYMBOL() {
            var s0;
            if (input.charCodeAt(peg$currPos) === 45) {
                s0 = peg$c21;
                peg$currPos++;
            }
            else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c22);
                }
            }
            return s0;
        }
        function peg$parseSPACE_SYMBOL() {
            var s0;
            if (input.charCodeAt(peg$currPos) === 32) {
                s0 = peg$c159;
                peg$currPos++;
            }
            else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c160);
                }
            }
            return s0;
        }
        function peg$parseFOLLOWING_SPACE_END() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c161) {
                s1 = peg$c161;
                peg$currPos += 2;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c162);
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$currPos;
                peg$silentFails++;
                s3 = peg$parseCOMMA_SYMBOL();
                peg$silentFails--;
                if (s3 !== peg$FAILED) {
                    peg$currPos = s2;
                    s2 = void 0;
                }
                else {
                    s2 = peg$FAILED;
                }
                if (s2 === peg$FAILED) {
                    s2 = peg$currPos;
                    peg$silentFails++;
                    if (input.length > peg$currPos) {
                        s3 = input.charAt(peg$currPos);
                        peg$currPos++;
                    }
                    else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c163);
                        }
                    }
                    peg$silentFails--;
                    if (s3 === peg$FAILED) {
                        s2 = void 0;
                    }
                    else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                }
                if (s2 !== peg$FAILED) {
                    s1 = [s1, s2];
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseESCAPED_DOUBLE_SPACE() {
            var s0;
            if (input.substr(peg$currPos, 3) === peg$c164) {
                s0 = peg$c164;
                peg$currPos += 3;
            }
            else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c165);
                }
            }
            return s0;
        }
        function peg$parseCARET() {
            var s0;
            if (input.charCodeAt(peg$currPos) === 94) {
                s0 = peg$c166;
                peg$currPos++;
            }
            else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c167);
                }
            }
            return s0;
        }
        function peg$parseescape() {
            var s0;
            if (input.charCodeAt(peg$currPos) === 92) {
                s0 = peg$c128;
                peg$currPos++;
            }
            else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c129);
                }
            }
            return s0;
        }
        function peg$parseescaped_quotation_mark() {
            var s0;
            if (input.substr(peg$currPos, 2) === peg$c168) {
                s0 = peg$c168;
                peg$currPos += 2;
            }
            else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c169);
                }
            }
            return s0;
        }
        function peg$parsequotation_mark() {
            var s0;
            if (input.charCodeAt(peg$currPos) === 34) {
                s0 = peg$c126;
                peg$currPos++;
            }
            else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c127);
                }
            }
            return s0;
        }
        function peg$parseunescaped() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = peg$currPos;
            peg$silentFails++;
            s2 = peg$parseSYMBOLS();
            peg$silentFails--;
            if (s2 === peg$FAILED) {
                s1 = void 0;
            }
            else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parsechar_range();
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c170(s2);
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsevalid_char() {
            var s0, s1;
            s0 = peg$currPos;
            s1 = peg$parsechar_range();
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c170(s1);
            }
            s0 = s1;
            return s0;
        }
        function peg$parsechar_range() {
            var s0;
            if (peg$c171.test(input.charAt(peg$currPos))) {
                s0 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c172);
                }
            }
            return s0;
        }
        function peg$parseHEXDIG() {
            var s0;
            if (peg$c173.test(input.charAt(peg$currPos))) {
                s0 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c174);
                }
            }
            return s0;
        }
        peg$result = peg$startRuleFunction();
        if (peg$result !== peg$FAILED && peg$currPos === input.length) {
            return peg$result;
        }
        else {
            if (peg$result !== peg$FAILED && peg$currPos < input.length) {
                peg$fail(peg$endExpectation());
            }
            throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length
                ? input.charAt(peg$maxFailPos)
                : null, peg$maxFailPos < input.length
                ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
                : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
        }
    }
    return {
        SyntaxError: peg$SyntaxError,
        parse: peg$parse,
    };
})();
//# sourceMappingURL=filterGrammar.parser.js.map